package com.exura.common.domain.validation

sealed interface StringValidationState {
    data object Success : StringValidationState

    sealed interface Error : StringValidationState {
        data object Empty : Error
        data object Invalid : Error
    }
}
